/**
 * ADD_MEMBER_FAILURE
 */
function* addMemberFailure({ error }) {
  console.log('addMember')
}

export default addMemberFailure
